export enum PreviousOrderSuggestionOptions {
  BillingAddress = "billingAddress",
  DeliveryAddress = "deliveryAddress",
  EndCustomer = "endCustomer"
}
